import { Lightbox } from "./Lightbox.js";
export * from "./types.js";
export * from "./Lightbox.js";
export default Lightbox;
